// Passage du texte libre `serving_size` d'Open Food Facts (« 30 g », « 1 portion (25g) », « 330ml »,
// parfois absent ou non parseable) à un nombre de grammes exploitable pour mettre à l'échelle une
// composition pour 100 g (objectif § 5, « passage aux grammes »).

/**
 * Extrait un nombre de grammes (ou millilitres, assimilés en grammes) d'un `serving_size` OFF.
 * Renvoie `null` quand le champ est absent ou ne contient aucune quantité reconnaissable — dans ce
 * cas l'appelant retombe sur la saisie utilisateur, puis sur l'estimation du modèle.
 */
export function parseServingGrams(servingSize: string | null | undefined): number | null {
  if (!servingSize) return null;
  const match = /(\d+(?:[.,]\d+)?)\s*(g|ml)\b/i.exec(servingSize);
  if (!match) return null;
  const rawValue = match[1];
  const value = Number(rawValue?.replace(',', '.'));
  if (!Number.isFinite(value) || value <= 0) return null;
  return Math.round(value);
}
